import $ from 'jquery';

export const setupSiteInteractions = (): void => {
  const $body = $('body');

  $body.on('click', '.menu-icon', (e) => {
    e.preventDefault();
    $('.menu-icon').attr('aria-expanded', 'true');
    $body.addClass('menu-active');
    const firstNavLink = document.querySelector('.nav-vertical__logo') as HTMLElement | null;
    firstNavLink?.focus();
  });

  const verticalNav = document.getElementById('nav-vertical');
  if (verticalNav) {
    const navLinks = verticalNav.querySelectorAll('a');
    const firstFocusableElement = navLinks[0] as HTMLElement;
    const lastFocusableElement = navLinks[navLinks.length - 1] as HTMLElement;

    document.addEventListener('keydown', (e) => {
      const isTabPressed = e.key === 'Tab';
      const isEscapePressed = e.key === 'Escape' || e.key === 'Esc';

      if (isEscapePressed) {
        $body.removeClass('menu-active');
        $('.menu-icon').focus();
        $('.menu-icon').attr('aria-expanded', 'false');
      }

      if (!isTabPressed) return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    });

    firstFocusableElement?.focus();
  }

  $body.on('click touchstart', '.bg-black-menu', (e) => {
    e.preventDefault();
    $body.removeClass('menu-active');
    $('.menu-icon').focus();
    $('.menu-icon').attr('aria-expanded', 'false');
  });

  $(window).on('scroll', function onWindowScroll(this: Window) {
    if ($(this).scrollTop() > 1) {
      $('header').addClass('sticky');
    } else {
      $('header').removeClass('sticky');
    }
  });

  $('.mai-wrapper .mai-title').unwrap();
  $('.make-an-impression .mai-wrapper').matchHeight();

  $('.vote-now-wrapper').each(function initVoteNowWrapper(this: HTMLElement) {
    const $wrapper = $(this);
    const $mainSlider = $wrapper.find('.tfe-entrant-img-wrapper');
    const $secondSlider = $wrapper.find('.cyv-slider');
    const $dotsContainer = $wrapper.find('.tfe-dots');
    const $next = $wrapper.find('#tfe-next');
    const $prev = $wrapper.find('#tfe-prev');

    $mainSlider.slick({
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      appendDots: $dotsContainer,
      asNavFor: $secondSlider,
    });

    $secondSlider.slick({
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      asNavFor: $mainSlider,
    });

    $prev.on('click', (e) => {
      e.preventDefault();
      $mainSlider.slick('slickPrev');
      return false;
    });

    $next.on('click', (e) => {
      e.preventDefault();
      $mainSlider.slick('slickNext');
      return false;
    });
  });

  $('.submit-photo-wrapper').each(function initSubmitPhotoWrapper(this: HTMLElement) {
    const $wrapper = $(this);
    const $photoUpload = $wrapper.find('.sp-photo-upload');
    const $caption = $wrapper.find('.sp-caption');
    const $registration = $wrapper.find('.sp-registration');
    const $age = $wrapper.find('.sp-age-wrapper');
    const $interested = $wrapper.find('.sp-interested');

    const $photoUploadLabelWrapper = $photoUpload.find('.input-label');
    const $photoUploadInputWrapper = $photoUpload.find('.input-field');
    const $photoUploadWrapper = $photoUploadLabelWrapper.parent();

    $photoUploadLabelWrapper
      .empty()
      .removeClass()
      .addClass('sp-photo-upload-left')
      .append("<span class='sp-header'>Upload your photo*</span>")
      .append("<span class='sp-text'>Supported formats: .jpg, .gif, .png</span>");

    $photoUploadInputWrapper.removeClass().addClass('sp-photo-upload-right');
    $photoUploadWrapper.removeClass().addClass('sp-photo-upload');

    $caption.find('.input-label').find('label').addClass('sp-header');
    $caption.find('.input-field').find('textarea').addClass('sp-caption-input');

    $registration.find('.input-row').removeClass();
    $registration.find('.input-label').addClass('visually-hidden');
    $registration.find('input').addClass('sp-input-text');

    const $ageLegend = $age.find('legend');
    const $ageAllInputs = $age.find('input');
    const $ageCheckbox = $age.find("input[type='checkbox']");
    const $ageCheckboxWrapper = $age.find('.checkbox');
    const $ageNewLabel = $(
      "<label class='sp-text'>Your age confirmation: I confirm that I am at least 18 years old</label>",
    );

    $ageLegend.addClass('visually-hidden');
    $ageAllInputs.insertBefore($ageCheckboxWrapper);
    $ageCheckboxWrapper.remove();

    let ageCheckboxID = $ageCheckbox.attr('id');
    if (!ageCheckboxID) {
      ageCheckboxID = 'age-check';
      $ageCheckbox.attr('id', ageCheckboxID);
    }
    $ageNewLabel.attr('for', ageCheckboxID);
    $ageCheckbox.parent().prepend($ageNewLabel);

    $interested.find('legend').addClass('sp-header');
    $interested.find('.checkbox').addClass('sp-interested-line');
    $interested.find('label').addClass('sp-text');
  });

  $('.take-over .row').removeClass('row');

  $('.rally-dropdown-btn').on('click', function onRallyDropdown(this: HTMLElement) {
    $(this).next('.rally-nav-list').slideToggle();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active').attr('aria-expanded', 'false');
    } else {
      $(this).addClass('active').attr('aria-expanded', 'true');
    }
  });

  $('.rally-nav-link').on('click', function onRallyNavLink(this: HTMLElement) {
    const rallyBtnLabel = $(this).parents('.rally-dropdown').find('.rally-dropdown-selected');
    $(this).closest('.rally-nav-list').slideUp();
    rallyBtnLabel.html($(this).html());
  });
};
